module.exports = __webpack_public_path__ + "static/img/carousel_1_quelbo_ar_16_9_w_2213.6df14cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_1_quelbo_ar_16_9_w_2213.jpg
// module id = WgDD
// module chunks = 0